import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface IMessage {
  id: string;
  type: 'success' | 'error';
  text: string;
}

export interface IMessagesState {
  messages: IMessage[];
}

const initialState: IMessagesState = {
  messages: []
};

export const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    addMessage: (state, action: PayloadAction<{ type: 'success' | 'error'; text: string }>) => {
      const id = Date.now().toString();
      const newMessage: IMessage = { 
        id, 
        type: action.payload.type, 
        text: action.payload.text 
      };
      state.messages.push(newMessage);
    },
    removeMessage: (state, action: PayloadAction<string>) => {
      state.messages = state.messages.filter(msg => msg.id !== action.payload);
    },
    clearMessages: (state) => {
      state.messages = [];
    }
  },
});

export const { addMessage, removeMessage, clearMessages } = messagesSlice.actions;
export default messagesSlice.reducer; 